export default "__VITE_ASSET__DC0n4F6t__"